import React from 'react';

const Library = () => {
  return (
    <div className="min-h-screen bg-stone-50">
      {/* Library Section */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Library
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Coming soon...
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Library;
